import { render, staticRenderFns } from "./PrivatePersonForm.vue?vue&type=template&id=b10c0260&scoped=true&"
import script from "./PrivatePersonForm.vue?vue&type=script&lang=js&"
export * from "./PrivatePersonForm.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePersonForm.vue?vue&type=style&index=0&id=b10c0260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10c0260",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/evolvo/klientai.cramo.lt/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VFlex,VForm,VLayout,VTextField})
